
import { Vue, Component } from 'vue-property-decorator'
import GuardCode from '@/types/guardCode'
import { units } from '@/globalValues'

@Component({
  components: {}
})

export default class GuardCodeShowDetailsTab extends Vue {
  settings = {
    routeNames: { list: 'guardCodes', show: 'guardCodeShow', edit: 'guardCodeEdit' },
    routeParamKey: 'guardCodeId',
    functionNames: { setCurrent: 'setCurrentGuardCode', save: 'saveGuardCode' },
    getterNames: { current: 'currentGuardCode', loading: 'loadingGuardCode', errors: 'guardCodeErrors' }
  }

  get currentItem () : GuardCode {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get units () : { name:string, value:string }[] {
    return units
  }
}
